export default __webpack_public_path__ + "static/media/SourceSerifPro-Italic.90931d6a.ttf";